import { AbstractControl, ValidationErrors } from "@angular/forms";
import { emailValidator } from "@scisys-uim/uim-common";

export function emailOrRangerSourceValidator (control: AbstractControl): ValidationErrors|null {
  const value = control?.value;
  if (value == null) {
    return null;
  }
  if (typeof value == 'string') {
    return emailValidator(control);
  }
  // Then we must be a RangerSourceMap
  return null;
}